import styled from 'styled-components';

export const StyledView = styled.div`
  h4, h5 {
    text-align: center;
  }
`;
